import Title from 'app/ui/display/Title';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import * as AppConstants from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

export default class HudLevelEnd extends Phaser.Group {
  constructor({ game }) {
    super(game);

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.3 });
    this.background.width = this.game.width;
    this.background.height = this.game.height;
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    // close button
    this.btnClose = new ButtonSimple({ game: this.game, id: 'btn_close', skin: 'btn_close' });
    this.btnClose.x = this.panel.width * 0.95;
    this.btnClose.y = this.btnClose.height / 4;
    this.btnClose.onInputDown.add(this.closePopup, this);
    this.container.addChild(this.btnClose);

    // add upper instruction text
    this.upperText = createTextField(this.game, AppConstants.FONT_COPY, 80, AppConstants.COPY_WHITE, 60, 0, {
      wordWrap: true,
      wordWrapWidth: this.panel.width * 0.9,
      boundsAlignH: 'center',
      boundsAlignV: 'middle',
      align: 'center',
    });

    this.upperText.anchor.set(0.5);
    this.upperText.text = this.game.copy.getCopy('how_to_play');
    this.upperText.x = this.panel.x + this.panel.width * 0.5;
    this.upperText.y = this.panel.y + 75;
    this.container.add(this.upperText);

    this.instructionImage = this.game.make.image(0, 0, 'ui', 'instructions');
    this.instructionImage.anchor.set(0.5);
    this.instructionImage.x = this.panel.width * 0.5;
    this.instructionImage.y = 230;
    this.container.add(this.instructionImage);

    this.lowerText = createTextField(this.game, AppConstants.FONT_COPY, 33, AppConstants.COPY_WHITE, 60, 0, {
      wordWrap: true,
      wordWrapWidth: this.panel.width * 0.9,
      align: 'center',
    });
    this.lowerText.lineSpacing = -5;

    this.lowerText.anchor.set(0.5);
    this.lowerText.text = this.game.copy.getCopy('how_to_play_' + (Phaser.Device.desktop ? 'desktop' : 'mobile'));
    this.lowerText.x = this.panel.width * 0.5;
    this.lowerText.y = this.instructionImage.y + this.instructionImage.height / 2 + 125;
    this.container.add(this.lowerText);

    // adjust panel positon based on title position
    // this.panel.y = this;

    this.onClose = new Phaser.Signal();

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    // this.fixedToCamera = true;
    this.handleScreenResize();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  /*
  ============================================================================================
    EVENT HANDLERS
  ============================================================================================
  */

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;

    this.background.width = this.game.width;
    this.background.height = this.game.height;
  }

  handleReplay() {
    this.game.controller.replayLevel();
    this.destroy();
  }

  handleNextLevel() {
    this.game.controller.nextLevel();
    this.destroy();
  }

  handleTryAgain() {
    this.game.controller.replayLevel();
    this.destroy();
  }

  closePopup() {
    this.onClose.dispatch();
    this.destroy(true);
  }
  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);
    this.btnClose.onInputDown.remove(this.closePopup, this);
    this.btnClose.destroy(true);
    this.panel.destroy(true);
    this.container.destroy(true);

    // nullify
    this.btnClose = null;
    this.panel = null;
    this.container = null;

    // super dupa
    super.destroy(true);
  }
}
